import INoteContentBuilder from "../Types/INoteContentBuilder";
import NoteTags from "../Types/NoteTags";
import TagSeriesNoteContentBuilder from "../Types/TagSeriesNoteContentBuilder";

const appointmentNoteTags = [
  NoteTags.serviceSubCategoryName,
  NoteTags.obxTag,
  NoteTags.businessUnitTag,
  NoteTags.patientHeightWeightBmiTag,
  NoteTags.patientDateOfBirthNoteTag,
  NoteTags.patientMedicalQualificationTimestampedNoteTag,
  NoteTags.patientDistanceToReservationCenterNoteTag,
  NoteTags.centerNameNoteTag,
  NoteTags.diabetesNoteTag,
  NoteTags.radiationProtectedAreasNoteTag,
  NoteTags.pacemakerWithoutDefibrillatorNoteTag
];

/** The union of props needed to build all tags in {@link AppointmentNoteContentBuilder}.
 * @remarks This type looks ugly, but is the only feasible way of building this type organically.
 */
export type AppointmentNoteTagProps = (typeof appointmentNoteTags)[number] extends {
  buildTagContent: (props: infer P) => unknown;
}
  ? P
  : never;

/** The composed {@link INoteContentBuilder} for building Appointment Notes. */
const AppointmentNoteContentBuilder: INoteContentBuilder<AppointmentNoteTagProps> =
  new TagSeriesNoteContentBuilder<AppointmentNoteTagProps>(appointmentNoteTags, " / ");

export default AppointmentNoteContentBuilder;
